var map = {
	"./adult/nn/ordforstaelse-data.json": 839,
	"./adult/no/ordforstaelse-data.json": 840,
	"./adult/se/ordforstaelse-data.json": 841,
	"./youth/de/ordforstaelse-data.json": 842,
	"./youth/nn/ordforstaelse-data.json": 843,
	"./youth/no/ordforstaelse-data.json": 844,
	"./youth/se/ordforstaelse-data.json": 845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 838;